import { Grid2 } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { Dispatch, SetStateAction } from 'react';
import { Toast } from 'react-bootstrap';

interface Props {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  message: string;
  messageType?: string;
}

const useStyles = makeStyles({
  toastBody: {
    width: 'auto',
    borderRadius: '4px',
    padding: '10px',
    '&.success': {
      backgroundColor: '#C0F3C6',
      border: '1px solid #C0F3C6',
      color: '#238E30',
    },
    '&.failure': {
      border: '1px solid #FFC4C4',
      background: '#FFF1F1',
      color: '#FF0D0D',
    },
  },
});

const Toaster: React.FC<Props> = ({ show, setShow, message, messageType }) => {
  const classes = useStyles();
  return (
    <Grid2 container justifyContent="center" mt="7px">
      <Toast
        show={show}
        onClose={() => setShow(false)}
        delay={3000}
        autohide
        style={{ boxShadow: 'none', textAlign: 'center' }}
      >
        <Toast.Body
          className={`${classes.toastBody} ${
            ['remove', 'failure'].includes(messageType || '') ? 'failure' : 'success'
          }`}
        >
          {message}
        </Toast.Body>
      </Toast>
    </Grid2>
  );
};

export default Toaster;
